<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="25%"
            height="100%"
            class="modalDialog"
            no-click-animation
            >
            <v-card class="pa-3">
                <CardTitle :title="page_title" />
                    <v-container>
                        <v-row class="pa-2">
                            <v-col cols="5" :class="labelObj">
                                <p>{{ golfCourseName }}</p>
                            </v-col>
                        </v-row>
                        <v-row class="pa-2">
                            <v-col cols="5" :class="labelObj">
                                <p>{{ courseName }}</p>
                            </v-col>
                        </v-row>
                        <v-row class="pa-2">
                            <v-col cols="5" :class="labelObj">
                                年月日
                            </v-col>
                            <v-col :class="labelObj">
                                {{ received.playDate }}
                            </v-col>
                        </v-row>
                    <v-form
                        ref="form"
                    >
                        <v-row>
                            <v-col cols="4" :class="labelObj">
                                時間
                            </v-col>
                            <v-col>
                                <v-text-field
                                    class="px-3"
                                    maxlength="5"
                                    type="time"
                                    placeholder="00:00"
                                    v-model="input.playStart"
                                    :rules='[rules.required]'
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" :class="labelObj">
                                予約ステータス
                            </v-col>
                            <v-col>
                                <v-select
                                    class="pa-2"
                                    :items="reserveStatusObj"
                                    item-value="code"
                                    item-text="code_name"
                                    v-model="input.reserveStatus"
                                    width="100px"
                                    :rules="[rules.required]"
                                    />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" :class="labelObj">
                                残席数
                            </v-col>
                            <v-col>
                                <v-select
                                    class="px-3"
                                    :items="playerLeftObj"
                                    item-value="code"
                                    item-text="code_name"
                                    v-model="input.playerLeft"
                                    :rules="[rules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                    <v-btn color="green darken-4" v-if="addStatus" text @click="displayAddOverLay">登録</v-btn>
                    <v-btn color="green darken-4" v-if="changeStatus" text @click="displayChangeOverLay">変更</v-btn>
                </v-card-actions>
                <AddOverLay
                    page-name="プレー時間"
                    @processing="createCellInfo"
                    @cancel="closeOverLay"
                    :process-result="process"
                    :OverlaySwitch="addOverlay"
                />
                <ChangeOverlay
                    page-name="プレー時間"
                    @processing="updateCellInfo"
                    @cancel="closeOverLay"
                    :process-result="process"
                    :OverlaySwitch="changeOverlay"
                />
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import { GET_CODE_LIST, GET_CODE_LIST_WITH_DEFAULT } from '@/constants/codelist';
import { authorityMixin } from '@/views/authorityMixin';
import {
    CREATE_CELL_INFO,
    UPDATE_CELL_INFO } from '@/constants/cell_info';
import AddOverLay from '@/components/overlay/AddOverlay';
import ChangeOverlay from '@/components/overlay/ChangeOverlay';
import validater from '@/lib/validater';

export default {
    components: {
        CardTitle,
        AddOverLay,
        ChangeOverlay
    },
    mixins: [authorityMixin],
    props: [
        'dialog',
        'modeStatus',
        'received'
    ],
    data () {
        return {
            // 追加確認用ポップアップ表示に関する制御値
            addOverlay: false,
            changeOverlay: false,
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            addStatus: false,
            changeStatus: false,
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // 入力値
            input: {
                playStart: '',
                reserveStatus: '',
                playerLeft: '',
                createdCode: '',
                update_type: 1
            },
            // プレイヤー人数
            playerLeftObj: {},
            reserveStatusObj: {},
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '時間追加',
            rules: {
                // 必須項目
                required: value => !!value || this.$t('error.validation.required.any'),
                // 氏名（姓）バリデーション
                onlyNumber: value => validater.checkNum(value) || this.$t('error.validation.num'),
                playerLeftValid: value => validater.checkPlayerLeftValid(value) || this.$t('error.validation.playerLeft')
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '001', element_name: '追加', isActive: true },
                { element_id: '002', element_name: '変更', isActive: true },
                { element_id: '003', element_name: '削除', isActive: true }
            ],
            vue_id: '',
            labelObj: {
                'd-flex': true,
                'align-self-center': true
            }
        };
    },
    async created () {
        this.reserveStatusObj = await this.getCodeList('reserve_status');
        // this.playerLeftObj = await this.GetCodeListWithDefault('play_number', '');
        this.playerLeftObj = await this.getCodeList('play_number');
    },
    watch: {
        // received: {
        //     handler (val) {
        //         console.log(val);
        //         this.input.reserveStatus = val.reserve_status;
        //         this.input.playStart = val.play_start;
        //         this.input.playerLeft = val.player_left;
        //     },
        //     deep: true
        // },
        modeStatus (val) {
            if (val === 'addMode') {
                this.addStatus = true;
                this.changeStatus = false;
            } else if (val === 'changeMode') {
                this.addStatus = false;
                this.changeStatus = true;
            }
        }
    },
    computed: {
        courseName () {
            const data = this.received.courseSelect.find(el => el.course_code === this.received.course);
            return data.course_name;
        },
        golfCourseName () {
            const data = this.received.golfSelection.find(el => el.golf_code === this.received.golfCourse);
            return data.golf_name;
        }
    },
    methods: {
        receivedCheck () {
            this.input.reserveStatus = this.received.reserve_status;
            this.input.playStart = this.received.play_start;
            this.input.playerLeft = this.received.player_left;
        },
        /** ----------------------------------------------
         * 登録処理
         * ---------------------------------------------- */
        createCellInfo () {
            this.$store.commit('loading/setIsLoading', true);
            this.$apollo.mutate({
                mutation: CREATE_CELL_INFO,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.received.golfCourse,
                    course_code: this.received.course,
                    play_date: this.received.playDate,
                    play_start: this.input.playStart,
                    reserve_status: this.input.reserveStatus,
                    player_left: this.input.playerLeft,
                    update_type: this.input.update_type
                }
            }).then(res => {
                const data = res.data.createCellInfo.result;
                if (data === 1) {
                    this.closeOverLay();
                    this.CloseModal();
                } else if (data === 0) {
                    const resultText = '同じプレー時間が登録されています。';
                    throw new Error(resultText);
                }
                this.$store.commit('loading/setIsLoading', false);
            }).catch(error => {
                error = error.message.split(/:/g);
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', error[0]);
                this.$store.commit('loading/setIsLoading', false);
            });
        },
        /** ----------------------------------------------
         * 変更処理
         * ---------------------------------------------- */
        updateCellInfo () {
            this.$store.commit('loading/setIsLoading', true);
            this.$apollo.mutate({
                mutation: UPDATE_CELL_INFO,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.received.golfCourse,
                    course_code: this.received.course,
                    play_date: this.received.playDate,
                    play_start: this.input.playStart,
                    reserve_status: this.input.reserveStatus,
                    player_left: this.input.playerLeft,
                    cell_id: this.received.cell_id,
                    update_type: this.input.update_type
                }
            }).then(res => {
                const data = res.data.updateCellInfo.result;
                if (data === 1) {
                    this.closeOverLay();
                    this.CloseModal();
                } else if (data === 0) {
                    const resultText = '同じプレー時間が登録されています。';
                    throw new Error(resultText);
                }
                this.$store.commit('loading/setIsLoading', false);
            }).catch(error => {
                error = error.message.split(/:/g);
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', error[0]);
                this.$store.commit('loading/setIsLoading', false);
            });
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayAddOverLay () {
            if (this.$refs.form.validate()) {
                this.addOverlay = true;
            }
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayChangeOverLay () {
            this.changeOverlay = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる処理
         * ---------------------------------------------- */
        closeOverLay () {
            this.addOverlay = false;
            this.changeOverlay = false;
            this.$set(this.process, 'result', '');
            this.$set(this.process, 'resultText', '');
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.$set(this.input, 'playStart', '');
            this.$set(this.input, 'reserveStatus', '');
            this.$set(this.input, 'playerLeft', '');
            this.$set(this.input, 'createdCode', '');
            this.$refs.form.resetValidation();
            this.$emit('close');
        },
        getCodeList (code) {
            return this.$apollo.query({
                query: GET_CODE_LIST,
                variables: {
                    code_key: code,
                    default_display: 0
                }
            }).then(res => {
                return res.data.GetCodeList.CodeList;
            });
        },
        GetCodeListWithDefault (pramCodeKey, defaultDisplay) {
            return this.$apollo.query({
                query: GET_CODE_LIST_WITH_DEFAULT,
                variables: { code_key: pramCodeKey, default_display: defaultDisplay }
            }).then(res => {
                return res.data.GetCodeListWithDefault.CodeList;
            });
        }
    }
};
</script>

<style scoped>
</style>
